export default "__VITE_ASSET__DXYIzu73__"